import { render, staticRenderFns } from "./StandardAccountRegister.vue?vue&type=template&id=db6b7116&scoped=true&lang=pug"
import script from "./StandardAccountRegister.vue?vue&type=script&lang=ts"
export * from "./StandardAccountRegister.vue?vue&type=script&lang=ts"
import style0 from "./StandardAccountRegister.vue?vue&type=style&index=0&id=db6b7116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6b7116",
  null
  
)

export default component.exports